// Third-party Imports
import { createSlice } from '@reduxjs/toolkit'

export const kanbanSlice = createSlice({
  name: 'kanban',
  initialState: {
    columns: [],
    tasks: [],
    currentTaskId: null
  },
  reducers: {

    updateColumns: (state, action) => {
      state.columns = action.payload
    },



    addTask: (state) => {

      return state
    },


    getCurrentTask: (state, action) => {
      state.currentTaskId = action.payload
    }
  }
})

export const {

  updateColumns,
  addTask,
  getCurrentTask
} = kanbanSlice.actions

export default kanbanSlice.reducer
